import {Grid, GridProps, SxProps} from '@mui/material';
import {ReactElement} from 'react';
import {Labeled} from 'react-admin';

interface LabeledGridItemProps extends GridProps {
    children: ReactElement;
    sx: SxProps;
}

export const LabeledGridItem = (props: LabeledGridItemProps) => {
    const {children, sx, ...rest} = props;

    return (
        <Grid {...rest} item >
            <Labeled sx={sx}>{children}</Labeled>
        </Grid>
    );
};
